import React, { Component } from 'react'

class CustomA extends Component {
  state = {}
  render() {
    return (
      <React.Fragment>
        <a
          href={this.props.href}
          target={this.props.target}
          className="custom-link"
        >
          {' '}
          {this.props.children}{' '}
        </a>
      </React.Fragment>
    )
  }
}

CustomA.defaultProps = { target: '' }

export default CustomA
